<template>
    <div class="ia-analysis-container">
        <h5 class="text-primary d-flex align-items-center">
            <span class="material-icons mr-2" style="font-size: 1.5em;">smart_toy</span>
            <span>Correções e Análise com Inteligência Artificial</span>
        </h5>
        
        <p class="text-muted small">
            Selecione as petições abaixo para gerar uma nova correção em lote ou visualize o histórico de interações da IA neste processo.
        </p>

        <div class="card mb-4 border-primary">
            <div class="card-header bg-primary text-white py-2">
                <div class="d-flex justify-content-between align-items-center">
                    <strong><span class="material-icons" style="font-size: 16px; vertical-align: middle;">add_circle</span> Nova Correção do Professor</strong>
                    <button class="btn btn-sm btn-light text-primary font-weight-bold" @click="toggleSelectAll">
                        {{ allSelected ? 'Desmarcar Todas' : 'Marcar Todas' }}
                    </button>
                </div>
            </div>
            
            <div class="card-body p-0">
                <div class="p-2" style="max-height: 200px; overflow-y: auto; background-color: #fff;">
                    <div v-if="peticoes && peticoes.length > 0">
                        <div v-for="peticao in peticoes" :key="peticao.id" class="custom-control custom-checkbox py-1 border-bottom">
                            <input type="checkbox" class="custom-control-input" :id="`chk-pet-${peticao.id}`" :value="peticao.id" v-model="selectedPeticoes">
                            <label class="custom-control-label w-100" :for="`chk-pet-${peticao.id}`" style="cursor: pointer;">
                                <span class="text-dark font-weight-bold">{{ peticao.descricao || '(Sem descrição)' }}</span>
                                <br>
                                <small class="text-muted">Anexado em: {{ new Date(peticao.created_at).toLocaleDateString('pt-BR') }}</small>
                            </label>
                        </div>
                    </div>
                    <div v-else class="text-center text-muted py-3">
                        <span class="material-icons" style="font-size: 16px; vertical-align: middle;">folder_open</span> Nenhuma petição disponível neste processo.
                    </div>
                </div>
            </div>
            
            <div class="card-footer bg-light">
                <button 
                    class="btn btn-success btn-block shadow-sm" 
                    :disabled="selectedPeticoes.length === 0 || loading" 
                    @click="analisarPeticoes">
                    <span v-if="loading">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Pensando...
                    </span>
                    <span v-else>
                        <span class="material-icons" style="font-size: 16px; vertical-align: middle;">play_arrow</span> Gerar Correção com IA
                    </span>
                </button>
            </div>
        </div>

        <div v-if="historico.length > 0">
            <h6 class="border-bottom pb-2 mb-3 text-secondary">
                <span class="material-icons" style="font-size: 16px; vertical-align: middle;">history</span> Histórico de uso da IA neste Processo
            </h6>
            
            <div class="accordion" id="accordionIA">
                <div class="card mb-2 shadow-sm" v-for="(item, index) in historico" :key="index">
                    <div class="card-header p-0" :id="`heading${index}`" style="background-color: #fff;">
                        <h2 class="mb-0">
                            <button class="btn btn-block text-left py-3 px-3 d-flex justify-content-between align-items-center" 
                                type="button" 
                                @click="toggleItem(index)"
                                :aria-expanded="openIndex === index ? 'true' : 'false'">
                            
                            <div class="flex-grow-1 mr-3"> <span class="badge badge-pill mr-2 p-2" :class="getBadgeClass(item)">
                                    <span class="material-icons" style="font-size: 14px; vertical-align: middle;">{{ getBadgeIcon(item) }}</span>
                                    {{ getBadgeLabel(item) }}
                                </span>

                                <span class="font-weight-bold text-dark">
                                    {{ item.nome_usuario || 'Usuário' }}
                                    <small v-if="Number(item.usuario_is_admin)" class="text-muted">(Professor)</small>
                                </span>

                                <div class="alert alert-secondary p-2 mb-2 mt-2 border-0">
                                    <small class="text-uppercase text-muted font-weight-bold">{{ getBadgeContext(item) }}</small>
                                    <div class="content-preview mt-1" v-html="formatarConteudoEnviado(item.conteudo_enviado)"></div>
                                </div>
                            </div>

                            <small class="text-muted flex-shrink-0">
                                <span class="material-icons" style="font-size: 14px; vertical-align: middle;">schedule</span> {{ new Date(item.created_at).toLocaleString('pt-BR') }}
                                <span class="material-icons ml-2" style="font-size: 16px; vertical-align: middle;">{{ openIndex === index ? 'expand_less' : 'expand_more' }}</span>
                            </small>
                        </button>
                        </h2>
                    </div>

                    <div v-show="openIndex === index">
                        <div class="card-body bg-light">
                            

                            <div class="card">
                                <div class="card-body p-3 force-text-dark">
                                    <h6 class="card-title text-success mb-3"><span class="material-icons" style="font-size: 16px; vertical-align: middle;">smart_toy</span> Resposta da IA:</h6>
                                    <div class="ai-response" v-html="formatarRespostaIA(item.resposta_recebida)"></div>
                                </div>
                                <div class="card-footer p-2 text-right bg-white">
                                    <!-- <small class="text-muted">Modelo: {{ item.modelo }} | Tokens: {{ item.qtd_total_tokens }}</small> -->
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div v-else class="text-center py-5 text-muted border rounded bg-white mt-3">
            <span class="material-icons mb-3" style="font-size: 3em; color: #ccc;">inbox</span><br>
            Nenhum histórico de análise encontrado para este processo.<br>
            <small>As correções do professor e sugestões dos alunos aparecerão aqui.</small>
        </div>
    </div>
</template>

<script>
const BASE_URL = window.Laravel.baseUrl;

export default {
    props: {
        processo: {
            type: Object,
            required: true
        },
        peticoes: {
            type: Array,
            default: () => []
        },
        userId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            selectedPeticoes: [],
            loading: false,
            historico: [],
            openIndex: null
        };
    },
    computed: {
        allSelected() {
            return this.peticoes.length > 0 && this.selectedPeticoes.length === this.peticoes.length;
        }
    },
    methods: {
        toggleItem(index) {
            this.openIndex = this.openIndex === index ? null : index;
        },
        getBadgeClass(item) {
            // Se for correção, amarelo (atenção). Se for sugestão, azul (info).
            return item.tipo_interacao === 'correcao' 
                ? 'badge-warning text-dark' 
                : 'badge-info';
        },

        // Define o ícone (retorna nome do Material Icon)
        getBadgeIcon(item) {
            return item.tipo_interacao === 'correcao' 
                ? 'check_circle'   // Ícone de checagem/correção
                : 'lightbulb';     // Ícone de ideia/sugestão
        },

        getBadgeContext(item){
            if (item.tipo_interacao === 'correcao') {
                return 'Petição(ões) Analisadas:';
            }
            return 'Contexto Analisado:';
        },

        // Define o texto
        getBadgeLabel(item) {
            if (item.tipo_interacao === 'correcao') {
                return 'Correção / Análise';
            }
            return 'Sugestão ao Peticionar';
        },

        toggleSelectAll() {
            if (this.allSelected) {
                this.selectedPeticoes = [];
            } else {
                this.selectedPeticoes = this.peticoes.map(p => p.id);
            }
        },

        formatarConteudoEnviado(texto) {
            if (!texto) return '<em>Sem conteúdo registrado</em>';
            let limpo = texto.replace("newPeticaoFromFile", "").trim();
            // Se o texto for muito curto e não tiver HTML, converte quebras de linha
            if (!limpo.includes('<') && limpo.includes('\n')) {
                limpo = limpo.replace(/\n/g, '<br>');
            }
            return limpo;
        },

        /* formatarRespostaIA(texto) {
            if (!texto) return '';
            // Remove as marcações de código markdown
            let limpo = texto.replace(/^```html/g, "").replace(/^```/g, "").replace(/```$/g, "");
            return limpo;
        }, */

        formatarRespostaIA(texto) { //Função importante! Ela limpa o retorno da IA para que o CSS que a IA retorna não afete a página.
            if (!texto) return '';

            let limpo = texto;

            // 1. Remove blocos de código markdown
            limpo = limpo.replace(/^```html/g, "").replace(/^```/g, "").replace(/```$/g, "");

            // 2. Remove blocos de style e script para segurança
            limpo = limpo.replace(/<style\b[^>]*>[\s\S]*?<\/style>/gi, "");
            limpo = limpo.replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, "");

            // 3. Remove tags estruturais
            const tagsEstruturais = [
                /<!DOCTYPE[^>]*>/gi,
                /<\/?html[^>]*>/gi,
                /<\/?head[^>]*>/gi,
                /<\/?body[^>]*>/gi
            ];

            tagsEstruturais.forEach(regex => {
                limpo = limpo.replace(regex, '');
            });

            return limpo.trim();
        },

        buscarHistorico() {
            axios.get(`${BASE_URL}chatgpt/historico_processo/${this.processo.id}`)
                .then(res => {
                    this.historico = res.data.sugestoes || [];
                })
                .catch(err => {
                    console.error("Erro ao buscar histórico IA:", err);
                });
        },

        analisarPeticoes() {
            if (this.selectedPeticoes.length === 0) return;
            
            this.loading = true;
            
            axios.post(`${BASE_URL}chatgpt/analisar_processo`, {
                processo_id: this.processo.id,
                peticao_ids: this.selectedPeticoes
            })
            .then(res => {
                // Feedback visual mais rico pode ser implementado aqui (ex: Toastr/Swal)
                alert("Análise concluída com sucesso!");
                this.buscarHistorico(); 
                this.selectedPeticoes = []; 
            })
            .catch(err => {
                const msg = err.response && err.response.data && err.response.data.error 
                    ? err.response.data.error 
                    : "Erro ao processar análise.";
                alert(msg);
            })
            .finally(() => {
                this.loading = false;
            });
        }
    },
    mounted() {
        this.buscarHistorico();
    }
};
</script>

<style scoped>
.ia-analysis-container {
    padding: 15px;
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 5px;
    margin-top: 10px;
}

/* Estilos para a resposta da IA (Correção de cor) */
.force-text-dark {
    color: #212529 !important;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    line-height: 1.6;
}
.force-text-dark ::v-deep p, 
.force-text-dark ::v-deep li, 
.force-text-dark ::v-deep div,
.force-text-dark ::v-deep h1,
.force-text-dark ::v-deep h2,
.force-text-dark ::v-deep h3,
.force-text-dark ::v-deep strong {
    color: #212529 !important;
}

/* Caixa de preview do conteúdo enviado */
.content-preview {
    max-height: 120px;
    overflow-y: auto;
    font-size: 0.85em;
    background-color: rgba(255, 255, 255, 0.7);
    padding: 8px;
    border-radius: 4px;
    border: 1px solid #e2e6ea;
    color: #495057;
}

/* Scrollbar personalizada suave para as áreas de rolagem */
.content-preview::-webkit-scrollbar,
.card-body::-webkit-scrollbar {
    width: 6px;
}
.content-preview::-webkit-scrollbar-thumb,
.card-body::-webkit-scrollbar-thumb {
    background-color: #adb5bd;
    border-radius: 10px;
}

/* Efeito hover nos itens do acordeão */
.btn-link:hover {
    text-decoration: none;
    background-color: #f8f9fa;
}

.text-light-gray {
    color: #d6d8db;
}
</style>